import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf, NgClass } from '@angular/common';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatFabButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector:        'app-no-data',
  templateUrl:     './no-data.component.html',
  styleUrls:       ['./no-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone:      true,
  imports:         [
    NgIf,
    MatCard,
    NgClass,
    MatIcon,
    MatFabButton,
    MatTooltip
  ]
})
export class NoDataComponent  {

  @Input()
  message = 'Keine Daten vorhanden';

  @Input()
  icon = 'cloud_off';

  @Input()
  hasAddButton = false;

  @Input()
  withShadow = true;

  @Input()
  showAsCard = true;

  @Output()
  public addButtonClick = new EventEmitter();





}
